import { Component } from '@angular/core';

@Component({
  selector: 'iots-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'shaman-finance-client';
}
